<template>
    <div id="viewIntroduce">
        <div>
            <p class="black title">끈기로 이뤄내는 개발자</p>
            <p class="black title">끈기로 이뤄내는 개발자</p>
        </div>
        <div>
            Web Backend Developer 최소원입니다.<br />
            대학교 2학년, 네트워크와 모바일 기술 강의를 들으며 웹페이지 제작을 처음 맛보게
            되었습니다.<br />
            생각을 표현하는게 재밌었고, 더 많은 기능들을 만들어 보고 싶었습니다.<br />
            웹 퍼블리싱 학원을 다니며 HTML, CSS, JavaScript, jQuery를 학습했습니다.<br />
            직접 기획하고 기능들을 하나씩 구현해가며 웹페이지를 완성했을 때, 프론트엔드 개발자라는
            꿈을 꾸게 되었습니다.<br />
            이후 Samsung Software Academy(SSAFY)에 입과하여 알고리즘, Computer Science, 다양한
            Framework를 학습했습니다.<br />
            현재, 이해할 수 있는 프로그램을 만드는 개발자가 되기위해 끊임없이 노력하고 있습니다.<br />

            <a href="https://career.programmers.co.kr/pr/sowon901" id="link"
                >경력 기술서 바로가기</a
            >
        </div>
    </div>
</template>
<script>
export default {
    name: "ViewIntroduce",
};
</script>
<style>
#viewIntroduce {
    margin-top: 300px;
}
#viewIntroduce > div {
    position: relative;
    padding: 0;
    margin: 0;
}
#viewIntroduce p {
    margin: 0;
}
#viewIntroduce > div > p:first-child {
    color: white;
    /* font-size: */
    text-shadow: -1px 0 #12104e, 0 1px #12104e, 1px 0 #12104e, 0 -1px #12104e;
}
#viewIntroduce > div > p:last-child {
    position: absolute;
    color: #12104e;
    z-index: -1;
    top: 6px;
    left: 8px;
}
#viewIntroduce > div:last-child {
    margin-top: 50px;
    margin-left: 100px;
    line-height: 1.6;
    font-size: 1.1em;
}
#link {
    display: inline-block;
    margin: 60px 0 0;
    padding: 0;
    color: #12104e;
    text-decoration: none;
    border-bottom: 1px solid #12104e;
}
</style>
